import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ['messages', 'windowContent', 'chatButton']
  static values = { lastMessageId: Number }
  messagesLoading = false
  page = 1
  newMessagesObserver

  connect() {
    this.scrollToBottom()

    this.newMessagesObserver = new MutationObserver(this.scrollToBottom.bind(this));
    this.startNewMessagesObserver()

    this.initInfiniteScroll()
  }

  startNewMessagesObserver() {
    this.newMessagesObserver.observe(this.messagesTarget, {
      childList: true
    });
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
  }

  toggle() {
    this.windowContentTarget.classList.toggle('display-none')
    this.chatButtonTarget.classList.toggle('display-none')
  }

  initInfiniteScroll() {
    const container = this.messagesTarget

    container.addEventListener('scroll', ()=> {
      if (container.scrollTop === 0 && !this.messagesLoading) {
        const oldHeight = container.scrollHeight;
        this.messagesLoading = true

        this.newMessagesObserver.disconnect()

        const scrollObserver = new MutationObserver((record)=> {
          this.messagesLoading = false
          container.scrollTop = container.scrollHeight - oldHeight
          scrollObserver.disconnect()
          this.startNewMessagesObserver()
        });

        scrollObserver.observe(this.messagesTarget, {
          childList: true
        });

        this.getMessages();
      }
    });
  }

  getMessages() {
    Turbo.visit(`/chat_messages?page=${++this.page}&from=${this.lastMessageIdValue}`, { historyChanged: true })
  }
}
